import { useLang } from "../contexts/LangContext";
import { IMAGES } from "../lib/images";
import useSEO from "../lib/useSEO";

export default function Philosophy() {
  const { t } = useLang();
  useSEO({
    title: "Philosophie — Qualität, Handwerk & Regionalität | Tæste Catering Lausitz",
    description:
      "Unsere Philosophie: Qualität, echtes Handwerk und Regionalität. Ausgewählte Zutaten und hausgemachte Rezepte für Pizza Catering und Events in der Lausitz.",
    keywords:
      "Tæste Philosophie, Pizza Handwerk, Regionale Zutaten Lausitz, Catering Lausitz, handgemachte Pizza Hoyerswerda",
    path: "/philosophie",
  });
  return (
    <div data-testid="philosophy-page" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 md:py-28">
      <div className="grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-7">
          <p className="eyebrow">{t.philosophy.eyebrow}</p>
          <h1 className="font-display text-5xl md:text-7xl mt-3 leading-[1.02]">{t.philosophy.title}</h1>
          <p className="mt-8 text-base md:text-lg text-[hsl(var(--muted-foreground))] leading-relaxed max-w-2xl">{t.philosophy.body}</p>
        </div>
        <div className="md:col-span-5">
          <img src={IMAGES.oven} alt="" className="w-full aspect-[4/5] object-cover" />
        </div>
      </div>

      <div className="mt-24 grid sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
        {t.philosophy.values.map(([h, b], i) => (
          <div key={h} data-testid={`philosophy-value-${i}`}>
            <span className="font-display text-2xl text-[hsl(var(--primary))]">0{i + 1}</span>
            <h3 className="font-display text-2xl mt-2">{h}</h3>
            <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
